import React from 'react';
import { doctorInfo } from '../data/mock';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="min-h-screen bg-white pt-24">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center py-16 lg:py-24">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <p className="text-sm uppercase tracking-widest text-[#b8860b] font-medium mb-4">
              Ibiza's Doctor
            </p>
            <h1 className="hero-large text-[#0f172a] mb-6">
              Dr. Carlos Castellon, M.D.
            </h1>
            <p className="body-large text-[#475569] mb-8 max-w-lg">
              {doctorInfo.tagline}
            </p>
            
            {/* Quote */}
            <blockquote className="border-l-3 border-[#b8860b] pl-6 mb-10 gold-accent">
              <p className="text-lg italic text-[#334155] leading-relaxed">
                "{doctorInfo.quote}"
              </p>
            </blockquote>

            <div className="flex flex-wrap gap-4">
              <Link to="/book" className="btn-primary" data-testid="hero-book-now">
                Book Now
              </Link>
              <a href="#contact" className="btn-secondary inline-flex items-center gap-2">
                Contact Us
                <ArrowRight size={16} />
              </a>
            </div>
          </div>

          {/* Hero Image */}
          <div className="order-1 lg:order-2 flex justify-center">
            <div className="relative max-w-md lg:max-w-lg">
              <img
                src={doctorInfo.mainImage}
                alt="Dr. Carlos Castellon - Ibiza's Doctor"
                className="w-full h-auto object-cover shadow-2xl"
              />
              {/* Gold corner accent */}
              <div className="absolute -bottom-3 -left-3 w-16 h-16 border-l-3 border-b-3 border-[#b8860b]"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hidden lg:flex justify-center pb-8">
        <div className="flex flex-col items-center gap-2 text-[#94a3b8]">
          <span className="text-xs uppercase tracking-widest">Scroll</span>
          <div className="w-px h-12 bg-[#b8860b]"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
